import { render } from "./EventView.vue?vue&type=template&id=d942821a&scoped=true"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"

import "./EventView.vue?vue&type=style&index=0&id=d942821a&scoped=true&lang=css"

import exportComponent from "D:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d942821a"]])

export default __exports__